import { Component, inject } from '@angular/core';
import { BrewersUnitOfWork } from 'app/core/core.module';
import { ProductCategory } from 'app/core/model/product-category';
import { DxFormModule } from 'devextreme-angular';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-product-category-dialog',
    standalone: true,
    imports: [DxFormModule],
    template: `
        <div class="modal-header">
            <h4 class="modal-title">{{ isNew ? 'Enter New' : 'Edit' }} Product Category</h4>
        </div>
        <div class="modal-body" (keyup.esc)="cancel()">
            <dx-form [formData]="productCategory">
                <dxi-item dataField="name"></dxi-item>
                <dxi-item dataField="description" editorType="dxTextArea" [editorOptions]="{ height: '125px' }"></dxi-item>
                <dxi-item dataField="isTaxable" editorType="dxCheckBox"></dxi-item>
            </dx-form>
        </div>
        <div class="modal-footer">
            <button class="btn btn-success" (click)="save()">Save</button>
            <button class="btn btn-light" (click)="cancel()">Cancel</button>
        </div>
    `,
    styles: [],
})
export class ProductCategoryDialogComponent {
    uow = inject(BrewersUnitOfWork);

    result = new Subject<{ success: boolean; value?: ProductCategory }>();
    productCategory: ProductCategory;
    isNew: boolean;
    unit: string;

    ngOnInit() {
        if (!this.productCategory) {
            this.isNew = true;
            this.productCategory = this.uow.productCategories.createEntity();
        }
    }

    save() {
        this.result.next({ success: true, value: this.productCategory });
    }

    cancel() {
        this.result.next({ success: false });
    }
}
